import { SERVICE_HOME } from '@/services';
import { HELPERS } from '@/utils';
import { GET_HOME_DATA, GET_HOME_LOADING, GET_LANDING_PAGE_DATA, GET_LANDING_PAGE_LOADING } from './home.types';

const getHomeData = () => {
  return (dispatch) => {
    dispatch({ type: GET_HOME_LOADING });

    SERVICE_HOME.getHomeData((res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);

      dispatch({
        type: GET_HOME_DATA,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

const getLandingPageData = () => {
  return (dispatch) => {
    dispatch({ type: GET_LANDING_PAGE_LOADING });

    SERVICE_HOME.getLandingPageData((res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);

      dispatch({
        type: GET_LANDING_PAGE_DATA,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

export const ACTION_HOME = { getHomeData, getLandingPageData };
